import DynamicBadge, {
	DynamicBadgeProps,
	dynamicBadgeClasses,
} from '@liquidweb-dev/undercurrent/DynamicBadge';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import { LWApiPublicAssetStatusT } from '@liquidweb-dev/club-sauce/public/asset/index.raw';
import { getStatusProps } from 'components/ServerStatusBadgeFlat';
import type { AssetDetails } from 'modules/queries/asset/useDetails';

export interface ServerStatusBadgeProps extends Partial<DynamicBadgeProps> {
	status: LWApiPublicAssetStatusT;
	powerStatus?: AssetDetails['powerStatus'];
	notificationPrimary?: string;
	notificationSecondary?: string;
}

const ServerStatusBadge = ({
	status,
	powerStatus,
	notificationPrimary,
	notificationSecondary,
	sx,
	...rest
}: ServerStatusBadgeProps) => {
	return (
		<DynamicBadge
			{...getStatusProps({
				status,
				powerStatus,
				notificationPrimary,
				notificationSecondary,
			})}
			sx={combineSx(
				({ size }) => ({
					height: size.md,
					width: size.md,
					[`&:hover`]: { zIndex: 2 },
					[`& .${dynamicBadgeClasses.icon}`]: { width: size.md },
					[`& .${dynamicBadgeClasses.primary}`]: {
						flexShrink: 0,
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						maxWidth: '100%',
					},
					[`& .${dynamicBadgeClasses.secondary}`]: {
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					},
				}),
				sx,
			)}
			{...rest}
		/>
	);
};

export default ServerStatusBadge;
